import React, { useEffect, useState } from "react";
import GetImage from "../../../components/getimage/Getimage";
import Micicon from "../../../assets/mic.png";
import Tint from "../../../utility/ImageTint/Tint";
import TooltipButton from "../../../components/tooltip/Popover";

export default function Step4({ userid, formData, setFormData, attendessarr }) {
  const [hostList, setHostList] = useState([]);
  const [selectedHostId, setSelectedHostId] = useState(userid);

  useEffect(() => {
    if (!attendessarr || !formData.attendees) return;

    let hosts = attendessarr.filter(emp =>
      formData.attendees.includes(emp.empid)
    );

    // userid wala employee top pe
    hosts.sort((a, b) => {
      if (a.empid === userid) return -1;
      if (b.empid === userid) return 1;
      return 0;
    });

    setHostList(hosts);

    // default selected host
    setSelectedHostId(userid);
    setFormData(prev => ({
      ...prev,
      hostempid: userid,
    }));

  }, [attendessarr, formData.attendees, userid]);

  const selectHost = (emp) => {
    setSelectedHostId(emp.empid);

    setFormData(prev => ({
      ...prev,
      hostempid: emp.empid,
    }));
  };

  return (
    <div>
      <p className="selectmeetingtime">Select Meeting Host <TooltipButton fieldName={"MeetingHost"}/></p>
       <div
      style={{
        maxHeight: "380px",
        overflowY: "auto",
        overflowX: "hidden",
        paddingRight: "5px",
        paddingBottom:"20vh"
        
      }}
      className="host-scroll"
    >
      
      <div className="row " >
        {hostList.map(emp => {
          const isSelected = selectedHostId === emp.empid;
          const isYou = userid === emp.empid;

          return (
            <div className="col-4 mb-2" key={emp.empid}>
              <div
                className="d-flex align-items-center p-2 justify-content-between"
                style={{
                  cursor: "pointer",
                  border: isSelected ? "1px solid #29b6f6" : "1px solid #f1f1f1",
                  borderRadius: "6px",
                  background: isSelected ? "#29b5f621" : ""
                }}
                onClick={() => selectHost(emp)}
              >
                <div className="d-flex align-items-center">
                  <GetImage
                    width="30px"
                    height="30px"
                    imgID={emp.empid}
                  />

                  <span style={{ fontSize: "14px", marginLeft: "8px" }}>
                    {emp.firstname} {emp.lastname}
                    {isYou && (
                      <span style={{ marginLeft: "5px", color: "#29b6f6", fontSize: "12px" }}>
                        (You)
                      </span>
                    )}
                  </span>
                </div>

                {isSelected && (
                  <img
                    src={Micicon}
                    style={{ width: "20px", filter: Tint("#e3121c") }}
                  />
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
    </div>
   
  );
}